import { render } from "./LangSwitcher.vue?vue&type=template&id=795f37c0"
import script from "./LangSwitcher.vue?vue&type=script&lang=js"
export * from "./LangSwitcher.vue?vue&type=script&lang=js"

import "./LangSwitcher.vue?vue&type=style&index=0&id=795f37c0&lang=scss"

import exportComponent from "/home/jeim2750/fuelguide.be/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__